import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CategoryFlags } from 'src/app/classes/DeviceCategoryFlags';

@Component({
  selector: 'app-categories-form',
  templateUrl: './categories-form.component.html',
  styleUrls: ['./categories-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoriesFormComponent implements OnChanges, OnDestroy {

  @Input() 
  categoryFlags: FormControl;

  @Input()
  required = true;

  @Input()
  multiple = true;

  categoryOptions: Array<{ key: number, label: string, selected: boolean }> = [];

  public validation_messages = {
    'categoryFlags': [
      { type: 'required', message: 'This field is required.' }
    ]
  };

  ngOnChanges() {
    this.initializeCategoryFlags();
    this.loadSelectedCategories();
  }

  ngOnDestroy() {
    this.initializeCategoryFlags();
  }

  updateCategories(rawValue: number | number[]): void {
    const categoryFlags = Array.isArray(rawValue) ? rawValue.reduce((flags, flag) => flags + Number(flag), 0) : rawValue;

    this.categoryFlags.patchValue(categoryFlags);
    this.categoryFlags.markAsTouched();
    this.categoryFlags.updateValueAndValidity();
  }

  loadSelectedCategories(): void {
    this.categoryOptions.forEach(category => {
      category.selected = (this.categoryFlags.value & category.key) > 0;
    });
  }

  initializeCategoryFlags(): void {
    this.categoryOptions = Object.keys(CategoryFlags)
      .filter(Number)
      .map(key => ({
        key: Number(key),
        label: CategoryFlags[key],
        selected: false
      }));
  }

}
